// BaseNode.js
// Abstract base component for all node types

import { Handle } from "reactflow";

export const BaseNode = ({
  id,
  data,
  title,
  description,
  handleConfig = [],
  children,
  width = 200,
  height = 140,
  style = {},
}) => {
  const defaultStyle = {
    width,
    height,
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: "16px",
    ...style,
  };

  return (
    <div style={defaultStyle}>
      {/* Render node handles */}
      {handleConfig.map((config) => (
        <Handle
          key={`${id}-${config.id}`}
          type={config.type}
          position={config.position}
          id={`${id}-${config.id}`}
          style={{
            top: config.top ? `${config.top}%` : undefined,
          }}
        />
      ))}

      {/* Node title */}
      <div
        style={{
          fontWeight: "bold",
          marginBottom: "6px",
          color: "#333",
        }}
      >
        {title}
      </div>

      {/* Optional description */}
      {description && (
        <div
          style={{
            fontSize: "12px",
            color: "#666",
            marginBottom: "6px",
          }}
        >
          {description}
        </div>
      )}

      {/* Custom node content */}
      {children && <div style={{ flex: 1 }}>{children}</div>}
    </div>
  );
};